import { components, useApi } from "@appretio/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { invalidateCubeMutation } from "../cubeMutationInvalidation";

type TimeTravelInput =
  | components["schemas"]["TimeTravelOffset"]
  | components["schemas"]["TimeTravelTimestamp"];

export function useTimeTravel() {
  const apiClient = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (input: TimeTravelInput) => {
      const response = await apiClient.POST("/v2/forecast/cubes/time-travel", {
        body: input
      });
      if (!response.data?.result) {
        throw new Error("Missing result in time travel response");
      }
      return response.data.result;
    },
    onSuccess: async () => {
      await invalidateCubeMutation(queryClient, { lifecycle: true });
    },
    meta: {
      errorMessage: "Failed to time travel"
    }
  });
}
